import { ExternalLink } from "lucide-react";

/**
 * A link to the norm behind a fiscal claim.
 *
 * Extracted from FiscalBenefitDeclaration, which established the pattern: when
 * we ask someone to declare something with tax consequences, the citation sits
 * next to the question rather than in a help page. An accountant ticking
 * "régimen especial" on a client's behalf should be able to check the article,
 * not take our label on trust.
 */
export function NormativaLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-primary underline-offset-2 transition-colors hover:underline"
    >
      {children}
      <ExternalLink className="h-3 w-3 shrink-0" aria-hidden />
    </a>
  );
}
